<template>
  <el-row :gutter="20" class="main_block">
    <div class="mianContent" style="height:auto">
      <div class="tagView">
        <div class="title_aside"></div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
        <el-col :span="16">
          <div class="contentBox">
            <div class="tel" v-if="false">
              <el-row
                  :gutter="20"
                  type="flex"
                  class="row-bg-content"
                  justify="space-between"
              >
                <el-col :span="4"><p>联合信任通行ID：</p></el-col>
                <el-col :span="18">
                  {{ userdata.id }}
                </el-col>
                <el-col :span="2">
                  <div class="grid-content bg-purple"></div>
                </el-col>
              </el-row>
            </div>
            <el-divider v-if="false"></el-divider>
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>注册时间：</p></el-col>
                <el-col :span="18">
                  {{ createdAt |formatDate  }}
                </el-col>
                <el-col :span="2">
                  <div class="grid-content bg-purple"></div>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
            <div class="tel">
              <el-row
                  :gutter="20"
                  type="flex"
                  class="row-bg-content"
                  justify="space-between"
              >
                <el-col :span="4"><p>用户名：</p></el-col>
                <el-col :span="18">
                  {{ userdata.username }}
                </el-col>

                <el-col :span="2">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      content="编辑用户名"
                      placement="top"
                  >
                    <div
                        class="imgSrc imgSrc1"
                        v-if="userdata.username === null"
                        @click="copyDialog = true"
                    ></div>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>绑定手机号：</p></el-col>
                <el-col :span="18">
                  {{ userdata.phone }}
                </el-col>
                <el-col :span="2">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      :content="userdata.phone ? '更换' : '绑定'"
                      placement="top"
                  >
                    <div
                        class="imgSrc imgSrc2"
                        @click="goNext('/userCenter/association','phone')"
                        :class="userdata.phone ? 'isPhoneTrue' : ''"
                    ></div>
                    <!-- <p class="isChange">{{userdata.phone ? '更换' : '绑定'}}</p> -->
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>绑定邮箱：</p></el-col>
                <el-col :span="18">
                  {{ userdata.email }}
                </el-col>
                <el-col :span="2">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      :content="userdata.email ? '更换' : '绑定'"
                      placement="top"
                  >
                    <div
                        class="imgSrc imgSrc2"
                        @click="goNext('/userCenter/association','email')"
                        :class="userdata.email ? 'isEmailTrue' : ''"
                    ></div>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
            <div v-if="$getlocalStorage('userData').parentId!=='0'">
                <div class="tel">
                  <el-row :gutter="20" type="flex" class="row-bg-content">
                    <el-col :span="4"><p>所属主账号：</p></el-col>
                    <el-col :span="20">
                      {{ userdata.adminAccount }}
                    </el-col>
                  </el-row>
                </div>
                <el-divider></el-divider>
            </div>
            
          </div>
        </el-col>
      </el-row>
      <!-- <div class="tagView tagView2">
        <div class="title_aside"></div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-if="$getlocalStorage('userData').parentId=='0'">
            认证信息 
          </el-breadcrumb-item>
          <el-breadcrumb-item v-else>主账号认证信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
        <el-col :span="16">
          <div class="contentBox">
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>认证状态：</p></el-col>
                <el-col
                    :span="18"
                    :class="
                    userdata.status === 1
                      ? 'isSuceess'
                      : userdata.status === -1 ||userdata.status === 3
                      ? 'isError'
                      : userdata.status === 2
                      ? 'isReject'
                      : userdata.status === 0
                      ? 'isCheck'
                      : ''
                  "
                >
                  {{
                    userdata.status === -1
                        ? "未认证"
                        : userdata.status === 0
                        ? "审核中"
                        : userdata.status === 1
                            ? "已认证"
                            : userdata.status === 2
                                ? "已拒绝"
                                : userdata.status === 3
                                    ? "未认证"
                                    : ""
                  }}
                  //个人，已认证但是不是银行卡四要素认证的
                  <b style="color:#999" v-if="userdata.type==1 && userdata.status === 1 && userdata.personal.authSource!==1">（若使用电子签名服务，请继续完善实名信息）</b>
                  //企业，ocr过了但没签署授权书
                  <b style="color:#999" v-if="userdata.type==2 && !(userdata.enterprise.status === 1 && userdata.enterprise.type==2)">（若使用电子签名服务，请继续完善实名信息）</b>
                </el-col>
                <el-col :span="2">
                  <div class="grid-content bg-purple" v-if="$getlocalStorage('userData').parentId=='0'">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                        userdata.status === -1 ||userdata.status === 3
                          ? '去认证'
                          : userdata.status === 2
                          ? '去修改'
                          : (userdata.type==1 && userdata.personal.authSource!==1)||(userdata.type==2 && !(userdata.enterprise.status === 1 && userdata.enterprise.type==2))
                          ? '去完善'
                          :''
                      "
                        v-if="userdata.status === -1 || userdata.status === 2 ||userdata.status === 3 || (userdata.status==1 
                        && 
                        //已认证但是个人或企业都需要待完善，详细看上面注释进行区分
                        ((userdata.type==1 && userdata.personal.authSource!==1)||(userdata.type==2 && !(userdata.enterprise.status === 1 && userdata.enterprise.type==2))))"
                        placement="top"
                    >
                      <div
                          class="imgSrc"
                          v-if="userdata.status === -1 ||userdata.status === 3 || userdata.status === 2"
                          @click="
                          $router.push({
                            path: '/userCenter/AuthenticationName',
                          })
                        "
                          :class="
                          userdata.status === -1 ||userdata.status === 3
                            ? 'isStatusTrue'
                            : userdata.status === 2
                            ? 'imgSrc1'
                            : ''
                        "
                      ></div>
                      //个人，已认证但是不是银行卡四要素认证的
                      <div
                          class="imgSrc imgSrc1"
                          v-if="userdata.type==1 && userdata.status==1 && userdata.personal.authSource !== 1"
                          @click="
                          $router.push({
                            path: '/userCenter/Personbank',
                          })
                        "
                      ></div>
                      //企业，ocr过了但没签署授权书
                      <div
                          class="imgSrc imgSrc1"
                          v-if="userdata.type==2 && !(userdata.enterprise.status === 1 && userdata.enterprise.type==2)"
                          @click="
                          $router.push({
                            path: '/userCenter/realName/authenticationType',
                          })
                        "
                      ></div>
                    </el-tooltip>
                  </div>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>认证类型：</p></el-col>
                <el-col :span="18">
                  {{
                    userdata.type === -1
                        ? ""
                        : userdata.type === 1 && userdata.status === 1
                        ? "个人认证"
                        : userdata.type === 2 && userdata.status === 1
                            ? "企业认证"
                            : ""
                  }}
                </el-col>
                <el-col :span="2">
                  <div class="grid-content bg-purple"></div>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>真实姓名/企业名称：</p></el-col>
                <el-col :span="18">
                  {{ userdata.idenName | processName }}
                </el-col>
                <el-col :span="2">
                  <div class="grid-content bg-purple"></div>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>认证证件号：</p></el-col>
                <el-col :span="18" v-if="userdata.uscc &&  userdata.name">
                  {{ userdata.uscc  |processName }}
                </el-col>
                <el-col :span="18" v-else>
                  {{ userdata.idCard|processName }}
                </el-col>
                <el-col :span="2">
                  <div class="grid-content bg-purple"></div>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
          </div>
        </el-col>
      </el-row> -->
      <div class="tagView tagView2">
        <div class="title_aside"></div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>其他信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
        <el-col :span="16">
          <div class="contentBox">
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>性别：</p></el-col>
                <el-col :span="18">
                  {{
                    userdata.gender === 0
                        ? "未知"
                        : userdata.gender === 1
                        ? "男"
                        : userdata.gender === 2
                            ? "女"
                            : "未设置"
                  }}
                </el-col>
                <el-col :span="2">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      content="编辑性别"
                      placement="top"
                  >
                    <div
                        class="imgSrc imgSrc1"
                        @click="copyDialog3 = true"
                    ></div>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>职业：</p></el-col>
                <el-col :span="18">
                  {{ userdata.job || "未填写" }}
                </el-col>
                <el-col :span="2">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      content="编辑职业"
                      placement="top"
                  >
                    <div
                        class="imgSrc imgSrc1"
                        @click="copyDialog1 = true"
                    ></div>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>联系方式：</p></el-col>
                <el-col :span="18">
                  {{ userdata.contractInformation || "未填写" }}
                </el-col>
                <el-col :span="2">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      content="编辑联系方式"
                      placement="top"
                  >
                    <div
                        class="imgSrc imgSrc1"
                        @click="telDialog4 = true"
                    ></div>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>联系地址：</p></el-col>
                <el-col :span="18">
                  {{ userdata.province || "选择地区" }}
                  {{ userdata.city }}
                  {{ userdata.county }}
                </el-col>
                <el-col :span="2">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      content="编辑信息"
                      placement="top"
                  >
                    <div
                        class="imgSrc imgSrc1"
                        @click="copyDialog2 = true"
                    ></div>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>详细地址：</p></el-col>
                <el-col :span="18">
                  {{ userdata.address || "未填写" }}
                </el-col>
                <el-col :span="2"></el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
            <div class="tel">
              <el-row :gutter="20" type="flex" class="row-bg-content">
                <el-col :span="4"><p>邮政编码：</p></el-col>
                <el-col :span="18">
                  {{ userdata.postcode || "未填写" }}
                </el-col>
                <el-col :span="2">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      content="编辑邮编"
                      placement="top"
                  >
                    <div
                        class="imgSrc imgSrc1"
                        @click="copyDialog4 = true"
                    ></div>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
            <el-divider></el-divider>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
        :visible.sync="copyDialog"
        title="设置用户名"
        width="40%"
        top="27vh"
        class="copyDialog copyDialog2 dialog1"
        center
    >
      <el-row :gutter="20" type="flex" class="row-bg" justify="center">
        <el-col :span="20">
          <el-form
              :model="modify"
              status-icon
              :rules="modifyRules1"
              ref="modifyRef"
              label-position="top"
          >
            <el-form-item
                label="用户名只支持设置一次"
                prop="loginName"
                label-width="65px"
            >
              <p class="rulesCopy">
                用户名设置规则：32位内数字+字母或符号组合，不允许输入非法字符。
                例：lianhexinren123或123_456
              </p>
              <el-input
                  type="text"
                  v-model="modify.loginName"
                  autocomplete="off"
                  placeholder="lianhexinren123或123_456"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="copyDialog = false">取消</el-button>
        <el-button round class="next" @click="saveUserName" type="primary"
        >保存</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
        title="编辑职业"
        :visible.sync="copyDialog1"
        width="30%"
        top="27vh"
        class="copyDialog copyDialog2"
        center
    >
      <el-row :gutter="20" type="flex" class="row-bg" justify="center">
        <el-col :span="20">
          <el-form
              :model="userData1"
              status-icon
              :rules="modifyRules2"
              ref="modify"
              label-position="left"
          >
            <el-form-item label="职业" prop="job" label-width="90px">
              <el-input
                  type="text"
                  v-model="userData1.job"
                  autocomplete="off"
                  placeholder="请输入职业，例律师、医生等"
                  clearable
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="copyDialog1 = false">取消</el-button>
        <el-button
            round
            class="next"
            @click="save('modify', { job: userData1.job }, '职业', 'copyDialog1')"
            type="primary"
        >保存</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        title="编辑地址"
        :visible.sync="copyDialog2"
        width="57%"
        top="27vh"
        class="copyDialog copyDialog2"
        center
    >
      <el-row :gutter="20" type="flex" class="row-bg" justify="center">
        <el-col :span="20">
          <AreaSelect @editArea="editArea(arguments)" :userdata="userData1"/>

          <el-form
              :model="userData1"
              status-icon
              :rules="addressRules"
              ref="modifyAddress"
              label-position="left"
          >
            <el-form-item label="详细地址" prop="address" label-width="90px">
              <el-input
                  type="textarea"
                  v-model="userData1.address"
                  autocomplete="off"
                  placeholder="请输入有效地址"
                  show-word-limit
                  maxlength="128"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="copyDialog2 = false">取消</el-button>
        <el-button
            round
            class="next"
            type="primary"
            @click="
            save(
              'modifyAddress',
              {
                province: userData1.province,
                county: userData1.county,
                city: userData1.city,
                address: userData1.address,
                postcode: userData1.postcode,
              },
              '信息',
              'copyDialog2'
            )
          "
        >
          保存</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        title="编辑性别"
        :visible.sync="copyDialog3"
        width="30%"
        top="27vh"
        class="copyDialog copyDialog2"
        center
    >
      <el-row :gutter="20" type="flex" class="row-bg" justify="center">
        <el-col :span="20">
          <el-form
              :model="userData1"
              :rules="modifyRules3"
              ref="modify3"
              label-position="left"
          >
            <el-form-item label="性别" prop="gender" label-width="90px">
              <el-select v-model="userData1.gender" placeholder="请选择性别">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="copyDialog3 = false">取消</el-button>
        <el-button
            round
            class="next"
            @click="
            save('modify3', { gender: userData1.gender }, '性别', 'copyDialog3')
          "
            type="primary"
        >保存</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        title="联系方式"
        :visible.sync="telDialog4"
        width="30%"
        top="27vh"
        class="copyDialog copyDialog2"
        center
    >
      <el-row :gutter="20" type="flex" class="row-bg" justify="center">
        <el-col :span="20">
          <el-form
              :model="userData1"
              :rules="telRules2"
              ref="telmodify"
              label-position="left"
          >
            <el-form-item label="电话" prop="contractInformation" label-width="90px">
              <el-input
                  type="number"
                  v-model="userData1.contractInformation"
                  autocomplete="off"
                  maxlength="50"
                  placeholder="请输入联系方式"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="telDialog4 = false">取消</el-button>
        <el-button
            round
            class="next"
            @click="
            save(
              'telmodify',
              { contractInformation: userData1.contractInformation },
              '联系方式',
              'telDialog4'
            )
          "
            type="primary"
        >保存</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        title="邮政编码"
        :visible.sync="copyDialog4"
        width="30%"
        top="27vh"
        class="copyDialog copyDialog2"
        center
    >
      <el-row :gutter="20" type="flex" class="row-bg" justify="center">
        <el-col :span="20">
          <el-form
              :model="userData1"
              :rules="postcodeRules"
              ref="postcodemodify"
              label-position="left"
          >
            <el-form-item label="邮编" prop="postcode" label-width="90px">
              <el-input
                  @keyup.native="postcodeNumber"
                  v-model="userData1.postcode"
                  autocomplete="off"
                  placeholder="请输入邮政编码"
                  maxlength="10"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="copyDialog4 = false">取消</el-button>
        <el-button
            round
            class="next"
            @click="
            save(
              'postcodemodify',
              { postcode: userData1.postcode },
              '邮政编码',
              'copyDialog4'
            )
          "
            type="primary"
        >保存</el-button
        >
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import {mapState, mapActions} from "vuex";
import AreaSelect from "@/components/AreaSelect";
import {
  userProfile,
  bindUserName,
  identification,
  userProfilePut,
} from "@http/user_center/userInfo";

export default {
  name: "userInfo",
  data() {
    var validapsw = (rule, value, callback) => {
      // let re = /^[a-zA-Z0-9]{1}(?=.*[0-9_.-]{1})(?=.*[a-zA-Z_.-]{1})[a-zA-Z0-9_.-]{2,30}$/;
      // let re = /^(?![0-9]*$)(?![a-zA-Z]*$)[0-9A-Za-z-_\~!\.\(\)\[\]\{\}<>\?\\\/\'\"\+;:,|=]{1,32}$/;
      let re = /^(?![0-9]+$)(?![a-zA-Z]+$)((?!@))[0-9A-Za-z-_]{2,32}$/;
      if (!value || !value.trim()) {
        callback(new Error("请输入用户名"));
      } else if (!re.test(value)) {
        callback(new Error("32位内数字+字母或符号组合，不允许输入非法字符如：()*&^%$#@"));
      }
      callback();
    };

    var validatel = (rule, value, callback) => {
      var isPhone =/(^0\d{2,3}\-\d{7,8}$)|(^1[3|4|5|6|7|8][0-9]{9}$)/;
      if (!value ) {
        callback(new Error("请输入联系方式"));
      } else if (!isPhone.test(value)  ) {
        callback(new Error("请输入正确联系方式"));
      }
      callback();
    };
    return {
      imgSrc1: require("@/assets/images/user/bianji.png"),
      imgSrc2: require("@/assets/images/user/huanbang.png"),
      imgSrc3: require("@/assets/images/user/genghuanbangding.png"),

      copyDialog: false,
      copyDialog1: false,
      copyDialog2: false,
      copyDialog3: false,
      copyDialog4: false,
      telDialog4: false,
      modifyRules3: {
        gender: [{required: true, trigger: "change", message: "请选择性别"}],
      },
      modifyRules1: {
        loginName: [{validator: validapsw, trigger: "blur"}],
      },
      modifyRules2: {
        job: [
          {required: true, trigger: "change", message: "请输入职业"},
          { min: 2, max: 50, message: '请输入2-50位之间的字符', trigger: 'blur' },
        ],
      },
      telRules2: {
        contractInformation: [{required: true, validator: validatel, trigger: "blur"}],
      },
      addressRules: {
        address: [{required: true, trigger: "change", message: "选择地区"}],
      },
      postcodeRules: {
        postcode: [{required: true, trigger: "change", message: "请输入邮政编码"}],
      },
      modify: {},
      userData1: {},
      postcodemodify: {},
      telmodify: {},
      postcode:'',
      options: [
        {label: "男", value: 1},
        {label: "女", value: 2},
      ],
    };
  },
  created() {
    this.userProfile();
    this.identification();
  },
  computed: {
    ...mapState({
      createdAt: state => state.userInfo.baseInfo.createdAt
    }),
    userdata: {
      get() {
        return this.$store.state.userInfo.userinfo;
      },
      set(val) {
        this.$store.state.userInfo.userinfo = val;
      },
    },
    channelCodeValue(){
        return this.$store.state.config.channelCodeValue;
    },
  },
  methods: {
    ...mapActions({
      serUserInfo: "userInfo/serUserInfo",
    }),
    postcodeNumber(){
      this.userData1.postcode=this.userData1.postcode.replace(/[^\.\d]/g,'');
      this.userData1.postcode=this.userData1.postcode.replace('.','');
    },
    // 其他信息
    async identification() {
      let res = await identification();
      if (res) {
        let idenInfo = {};
        if (res.status === 1 && res.type === 1) {
          idenInfo = res.personal;
        } else if (res.status === 1 && res.type === 2) {
          idenInfo = res.enterprise;
        }
        idenInfo.idenName=idenInfo.name;
        // console.log(idenInfo);
        let data = {...idenInfo, ...res, ...this.userdata};
        this.userdata = data;
        console.log(this.userdata);
      }
    },
    // 用户信息
    async userProfile() {
      let res = await userProfile();
      if (res) {
        let otherData = { ...this.userdata,...res,};
        this.userdata = otherData;
        if(this.userdata?.gender==0){
            this.userdata.gender=''
        }
        console.log(this.userdata);
      }
      this.$nextTick(() => {
        this.userData1 = this.$options.filters["deepClone"](this.userdata);
      });
    },
    // 所在地区
    editArea(data) {
      this.userData1.province = data[0];
      this.userData1.city = data[1];
      this.userData1.county = data[2];
    },
    // 保存用户名
    saveUserName() {
      let _this = this;
      _this.$refs.modifyRef.validate(async (valid) => {
        if (valid) {
          let res = await bindUserName({loginName: _this.modify.loginName});
          console.log(res);
          if (res.status === 403) {
            _this.copyDialog = true;
          } else {
            _this.userdata.username = res.username;
            _this.copyDialog = false;
            // this.$msg(`设置成功`, "success");
          }
        }
      });
    },

    // 其他信息修改
    /**
     * @param {string} validateDia
     * @param {object} params
     * @param {string} message
     * @param {string} dialogType
     */
    save(validateDia, params, message, dialogType) {
      let _this = this;
      _this.$refs[validateDia].validate(async (valid) => {
        if (valid) {
          this.userProfilePut(params, message).then((res) => {
            if (res) {
              dialogType === "copyDialog3"
                  ? (this.copyDialog3 = false)
                  : dialogType === "copyDialog2"
                  ? (this.copyDialog2 = false)
                  : dialogType === "copyDialog1"
                      ? (this.copyDialog1 = false)
                      : dialogType === "telDialog4"
                          ? (this.telDialog4 = false)
                          : dialogType === "copyDialog4"
                              ? (this.copyDialog4 = false)
                              : "";
            }
          });
        }
      });
    },

    // 更新信息
    /**
     * @param {object} data
     * @param {string} message
     * @return {object}
     */
    async userProfilePut(data, message) {
      let res = await userProfilePut(data);
      if (res) {
        this.$msg(`${message}更新成功`, "success");
        this.identification();
        this.userProfile();
      }
      return res;
    },

    // 关联账号
    goNext(data,type) {
        let zhugeText=''
        if(type=='phone'){
            if(this.userdata.phone){
                zhugeText='用户中心_想换绑手机号'
            }else{
                zhugeText='用户中心_想绑定手机号'
            }
        }else{
            if(this.userdata.email){
                zhugeText='用户中心_想换绑邮箱'
            }else{
                zhugeText='用户中心_想绑定邮箱'
            }
        }
        zhuge.track(zhugeText, {'渠道': this.channelCodeValue},()=> {
            this.$router.push({path:data}) //继续跳转到目标页面
        })
    },
  },
  components: {
    AreaSelect,
  },
};
</script>

<style scoped lang="less">
.rightPanel .mianContent {
  height: auto !important;
}

.isCheck {
  color: #3f7df7;
}

.isBule {
  color: #409eff;
}

.isError {
  color: #fb8d2a;
}

.isSuceess {
  color: #43a341;
}

.isReject {
  color: #ff3333;
}

.contentBox {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 32px;
}

.tagView2 {
  margin-top: 32px;
}

.tel {
  position: relative;

  .isChange {
    position: absolute;
    background-color: #dbdbdb;
  }
}

.imgSrc {
  width: 25px;
  height: 28px;
  background: no-repeat;
  background-position: center !important;
  cursor: pointer;
}

.imgSrc1 {
  background: url("../../assets/images/user/bianji (1).png") no-repeat;
  background-size: 79%;
}

.imgSrc1:hover {
  background: url("../../assets/images/user/bianji (1) 拷贝.png") no-repeat;
  background-size: 79%;
}

.imgSrc2 {
  background: url("../../assets/images/user/genghuanbangding.png") no-repeat;
  background-size: 75%;
}

.imgSrc2:hover {
  background: url("../../assets/images/user/genghuanbangding 拷贝.png") no-repeat;
  background-size: 75%;
}

.isPhoneTrue {
  background: url("../../assets/images/user/huanbang.png") no-repeat;
  background-size: 72%;
}

.isPhoneTrue:hover {
  background: url("../../assets/images/user/huanbang 拷贝.png") no-repeat;
  background-size: 72%;
}

.isEmailTrue {
  background: url("../../assets/images/user/huanbang.png") no-repeat;
  background-size: 72%;
}

.isEmailTrue:hover {
  background: url("../../assets/images/user/huanbang 拷贝.png") no-repeat;
  background-size: 72%;
}

.isStatusTrue {
  background: url("../../assets/images/user/jiantou (1) 默认.png") no-repeat;
  background-size: 70%;
}

.isStatusTrue:hover {
  background: url("../../assets/images/user/jiantou (1) 拷贝.png") no-repeat;
  background-size: 70%;
}

.row-bg-content {
  justify-content: space-between;
}

.dialog1 {
  /deep/ .el-form-item__label {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
    padding-bottom: 0;
  }
}

.rulesCopy {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 35px;
  margin-bottom: 10px;
}

.el-select {
  width: 80%;
}
</style>
